import { GlobalContext } from 'context/GlobalContext';
import { useContext } from 'react';

export function useGlobal() {
	return useContext(GlobalContext);
}
